import { ApplicationInsights } from "@microsoft/applicationinsights-web";
const instrumentationKey = process.env.REACT_APP_APPINSIGHTS_INSTRUMENTATIONKEY;

const appInsights = new ApplicationInsights({
  config: {
    instrumentationKey: instrumentationKey, // from Azure portal
    enableAutoRouteTracking: true, // optional, for SPA route changes
  },
});
appInsights.loadAppInsights();
export const setUserContext = (account) => {
  if (account) {
    const readableId = account.idTokenClaims?.preferred_username;
    const tenantId = account.idTokenClaims?.tid;
    if (readableId) {
      appInsights.setAuthenticatedUserContext(readableId, tenantId);
    }
  }
};
export default appInsights;